// import React, { useState } from 'react';
// import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
// import { FaUser, FaEnvelope, FaPhone, FaLock, FaEye, FaEyeSlash, FaArrowLeft } from 'react-icons/fa';
// import { Link, useNavigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';

// export default function PatientRegister() {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     password: '',
//     confirmPassword: '',
//     dateOfBirth: '',
//     gender: '',
//     address: '',
//     emergencyContact: '',
//     medicalHistory: ''
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   const navigate = useNavigate();
//   const { login } = useAuth();

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setSuccess('');

//     // Validation
//     if (formData.password !== formData.confirmPassword) {
//       setError('Passwords do not match');
//       return;
//     }

//     if (formData.password.length < 6) {
//       setError('Password must be at least 6 characters long');
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch('http://localhost:5000/api/auth/register', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           name: formData.name,
//           email: formData.email,
//           phone: formData.phone,
//           password: formData.password,
//           role: 'patient',
//           dateOfBirth: formData.dateOfBirth,
//           gender: formData.gender,
//           address: formData.address,
//           emergencyContact: formData.emergencyContact,
//           medicalHistory: formData.medicalHistory
//         }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         setSuccess('Registration successful! Redirecting to login...');
//         setTimeout(() => {
//           navigate('/patient/login');
//         }, 2000);
//       } else {
//         setError(data.message || 'Registration failed');
//       }
//     } catch (err) {
//       setError('Network error. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-vh-100 d-flex align-items-center" style={{ backgroundColor: '#f8fffe' }}>
//       <Container>
//         <Row className="justify-content-center">
//           <Col lg={8} xl={6}>
//             <div className="text-center mb-4">
//               <Link to="/" className="text-decoration-none">
//                 <Button variant="link" className="text-muted mb-3">
//                   <FaArrowLeft className="me-2" />
//                   Back to Home
//                 </Button>
//               </Link>
//               <h1 className="h2 fw-bold" style={{ color: '#0891b2' }}>
//                 Create Your Account
//               </h1>
//               <p className="text-muted">
//                 Join Aidify and start your healthcare journey today
//               </p>
//             </div>

//             <Card className="border-0 shadow-lg rounded-4">
//               <Card.Body className="p-5">
//                 {error && (
//                   <Alert variant="danger" className="mb-4">
//                     {error}
//                   </Alert>
//                 )}

//                 {success && (
//                   <Alert variant="success" className="mb-4">
//                     {success}
//                   </Alert>
//                 )}

//                 <Form onSubmit={handleSubmit}>
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="fw-bold">
//                           <FaUser className="me-2" />
//                           Full Name *
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           name="name"
//                           placeholder="Enter your full name"
//                           value={formData.name}
//                           onChange={handleInputChange}
//                           required
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="fw-bold">
//                           <FaEnvelope className="me-2" />
//                           Email Address *
//                         </Form.Label>
//                         <Form.Control
//                           type="email"
//                           name="email"
//                           placeholder="Enter your email"
//                           value={formData.email}
//                           onChange={handleInputChange}
//                           required
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="fw-bold">
//                           <FaPhone className="me-2" />
//                           Phone Number *
//                         </Form.Label>
//                         <Form.Control
//                           type="tel"
//                           name="phone"
//                           placeholder="Enter your phone number"
//                           value={formData.phone}
//                           onChange={handleInputChange}
//                           required
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="fw-bold">Date of Birth *</Form.Label>
//                         <Form.Control
//                           type="date"
//                           name="dateOfBirth"
//                           value={formData.dateOfBirth}
//                           onChange={handleInputChange}
//                           required
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="fw-bold">Gender *</Form.Label>
//                         <Form.Select
//                           name="gender"
//                           value={formData.gender}
//                           onChange={handleInputChange}
//                           required
//                         >
//                           <option value="">Select gender</option>
//                           <option value="male">Male</option>
//                           <option value="female">Female</option>
//                           <option value="other">Other</option>
//                         </Form.Select>
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="fw-bold">Emergency Contact</Form.Label>
//                         <Form.Control
//                           type="tel"
//                           name="emergencyContact"
//                           placeholder="Emergency contact number"
//                           value={formData.emergencyContact}
//                           onChange={handleInputChange}
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <Form.Group className="mb-3">
//                     <Form.Label className="fw-bold">Address</Form.Label>
//                     <Form.Control
//                       as="textarea"
//                       rows={2}
//                       name="address"
//                       placeholder="Enter your address"
//                       value={formData.address}
//                       onChange={handleInputChange}
//                     />
//                   </Form.Group>

//                   <Form.Group className="mb-3">
//                     <Form.Label className="fw-bold">Medical History</Form.Label>
//                     <Form.Control
//                       as="textarea"
//                       rows={3}
//                       name="medicalHistory"
//                       placeholder="Any relevant medical history (optional)"
//                       value={formData.medicalHistory}
//                       onChange={handleInputChange}
//                     />
//                   </Form.Group>

//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="fw-bold">
//                           <FaLock className="me-2" />
//                           Password *
//                         </Form.Label>
//                         <div className="position-relative">
//                           <Form.Control
//                             type={showPassword ? 'text' : 'password'}
//                             name="password"
//                             placeholder="Create a password"
//                             value={formData.password}
//                             onChange={handleInputChange}
//                             required
//                           />
//                           <Button
//                             type="button"
//                             variant="link"
//                             className="position-absolute end-0 top-0 text-muted"
//                             style={{ zIndex: 10 }}
//                             onClick={() => setShowPassword(!showPassword)}
//                           >
//                             {showPassword ? <FaEyeSlash /> : <FaEye />}
//                           </Button>
//                         </div>
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="fw-bold">
//                           <FaLock className="me-2" />
//                           Confirm Password *
//                         </Form.Label>
//                         <div className="position-relative">
//                           <Form.Control
//                             type={showConfirmPassword ? 'text' : 'password'}
//                             name="confirmPassword"
//                             placeholder="Confirm your password"
//                             value={formData.confirmPassword}
//                             onChange={handleInputChange}
//                             required
//                           />
//                           <Button
//                             type="button"
//                             variant="link"
//                             className="position-absolute end-0 top-0 text-muted"
//                             style={{ zIndex: 10 }}
//                             onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                           >
//                             {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                           </Button>
//                         </div>
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   <div className="d-grid gap-2 mt-4">
//                     <Button
//                       type="submit"
//                       disabled={loading}
//                       size="lg"
//                       className="py-3 rounded-pill fw-bold"
//                       style={{
//                         background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
//                         border: "none"
//                       }}
//                     >
//                       {loading ? 'Creating Account...' : 'Create Account'}
//                     </Button>
//                   </div>

//                   <div className="text-center mt-4">
//                     <p className="text-muted mb-0">
//                       Already have an account?{' '}
//                       <Link to="/patient/login" className="text-decoration-none fw-bold" style={{ color: '#0891b2' }}>
//                         Sign In
//                       </Link>
//                     </p>
//                   </div>
//                 </Form>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// }



import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { FaUser, FaEnvelope, FaPhone, FaCalendarAlt, FaVenusMars, FaNotesMedical } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import apiService from "../../services/api";
import emailjs from "emailjs-com";


export default function BookAppointment({setShowAppointmentModal}) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    dateOfBirth: '',
    gender: '',
    medicalHistory: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const navigate = useNavigate();
  const { login } = useAuth();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };



//   const handleSubmit = async (e) => {
//   e.preventDefault();
//   setError('');
//   setSuccess('');
//   setLoading(true);

//   const userData = {
//     name: formData.name,
//     email: formData.email,
//     phone: formData.phone,
//     role: 'patient',
//     dateOfBirth: formData.dateOfBirth,
//     gender: formData.gender,
//     medicalHistory: formData.medicalHistory,
//     password: '12345678', // Temporary password
//   };

//   try {
//     const response = await apiService.register(userData);

//     if (response.success) {
//       alert('Appointment booked successful! We will contact you soon.');
//       setSuccess('Appointment booked successfully!');
//       setShowAppointmentModal(false);

//       // Redirect if needed
//       // setTimeout(() => navigate('/patient/login'), 2000);
//     } else {
//       setError(response.error?.message || 'Booking failed');
//     }
//   } catch (err) {
//     setError('Network error. Please try again.');
//   } finally {
//     setLoading(false);
//   }
// };


const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setSuccess('');
  setLoading(true);

  const userData = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    role: 'patient',
    dateOfBirth: "1999-12-31",
    gender: "male",
    medicalHistory: "N/A",
    password: '12345678', // Temporary password
  };

  try {
    // ✅ Send details via EmailJS
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      // dateOfBirth: formData.dateOfBirth,
      // gender: formData.gender,
      // medicalHistory: formData.medicalHistory,
    };

    await emailjs.send(
      "service_op1gfeb",   // your service ID
      "template_t2nauyu", // create a separate template for patients in EmailJS
      templateParams,
      "0G5uZrnKX4OCn9jM0" // your public key
    )
    .then((response) => {
      console.log("Email sent SUCCESS!", response.status, response.text);
    })
    .catch((err) => {
      console.error("Email sending FAILED...", err);
    });

    // ✅ API call to save appointment
    const response = await apiService.register(userData);

    if (response.success) {
      alert('Appointment booked successfully! We will contact you soon.');
      setSuccess('Appointment booked successfully!');
      setShowAppointmentModal(false);

        if (window.fbq) {
        window.fbq('track', 'Lead', {
          content_name: 'Appointment',
          status: 'submitted',
          name: formData.name,
          email: formData.email,
          phone: formData.phone
        });
      }

      // setTimeout(() => navigate('/patient/login'), 2000);
    } else {
      setError(response?.message || 'Booking failed');
    }
  } catch (err) {
    setError(err?.message ||'Network error. Please try again.');
  } finally {
    setLoading(false);
  }
};


 return (
  <div
    className=" d-flex align-items-center"
    style={{ backgroundColor: "#f9fafb" }}
  >
    <Container>
      <Row className="justify-content-center">
        <Col>
          <Card className="border-0 shadow-lg rounded-4">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <p className="text-muted">
                  Fill in your details to schedule an appointment
                </p>
              </div>

              {error && <Alert variant="danger">{error}</Alert>}
              {success && <Alert variant="success">{success}</Alert>}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold" style={{ color: "#0891b2" }}>
                    <FaUser className="me-2" />
                    Full Name *
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold" style={{ color: "#0891b2" }}>
                    <FaEnvelope className="me-2" />
                    Email Address *
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold" style={{ color: "#0891b2" }}>
                    <FaPhone className="me-2" />
                    Phone Number *
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>

                {/* <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        className="fw-bold"
                        style={{ color: "#0891b2" }}
                      >
                        <FaCalendarAlt className="me-2" />
                        Date of Birth *
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="dateOfBirth"
                        value={formData.dateOfBirth}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        className="fw-bold"
                        style={{ color: "#0891b2" }}
                      >
                        <FaVenusMars className="me-2" />
                        Gender *
                      </Form.Label>
                      <Form.Select
                        name="gender"
                        value={formData.gender}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold" style={{ color: "#0891b2" }}>
                    <FaNotesMedical className="me-2" />
                    Medical History
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="medicalHistory"
                    placeholder="Any relevant medical history (optional)"
                    value={formData.medicalHistory}
                    onChange={handleInputChange}
                  />
                </Form.Group> */}

                <div className="d-grid mt-4">
                  <Button
                    type="submit"
                    disabled={loading}
                    size="lg"
                    className="py-3 rounded-pill fw-bold"
                    style={{
                      background:
                        "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                      border: "none",
                      boxShadow: "0 6px 18px rgba(8,145,178,0.3)",
                      color: "#fff",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 25px rgba(8,145,178,0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 6px 18px rgba(8,145,178,0.3)";
                    }}
                  >
                    {loading ? "Booking..." : "Book Appointment"}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </div>
);

}
